import {Typography} from "@mui/material";
import SectionHeaderProps from "@/src/_types/SectionHeaderProps";

const SectionHeader = ({title, subtitle}: SectionHeaderProps) => (
    <>
        <Typography
            component="h4"
            sx={{
                textAlign: "left",
                fontWeight: 700,
                fontSize: '1.375rem',
                color: (theme) => theme.palette.text.primary
            }}>
            {title}
        </Typography>
        <Typography variant="fs7" component="p"
                    sx={{textAlign: "left", color: (theme) => theme.palette.custom?.subtitleText}}>
            {subtitle}
        </Typography>
    </>
);

export default SectionHeader;
